import { Grid2 } from '@aibees/shared/components';
import { styled } from '@mui/material/styles';
import { Link as BaseLink } from 'react-router-dom';

export const Wrapper = styled(Grid2)``;

export const Link = styled(BaseLink)`
  font-size: ${(p) => p.theme.typography.body5.fontSize};
  font-weight: ${(p) => p.theme.typography.fontWeightSemiBold};
  color: ${(p) => p.theme.palette.primary[500]};
  text-decoration: none;
`;
